module.exports = __webpack_public_path__ + "static/media/plus_yellow.e9bd6231.svg";